<template>
  <div class="desktop">
    <div class="desktop--nav">
      <NavList></NavList>
    </div>
  </div>
</template>

<script>
import NavList from "./NavList";

export default {
  components: {
    NavList
  }
};
</script>

<style scoped lang="scss">
</style>